export default "__VITE_ASSET__CXxqwE0a__"